import React from "react";
import { style } from "typestyle";
import { Button, ButtonStyleTypes } from "@traceair/tds";

interface MapControlConfirmProps {
  onConfirm: () => void;
  onCancel: () => void;
}
const MapControlConfirm = ({ onConfirm, onCancel }: MapControlConfirmProps) => (
  <div
    className={style({
      display: "flex",
      $nest: {
        "&>*": {
          marginRight: "12px",
        },
        "&>*:last-child": {
          marginRight: 0,
        },
      },
    })}
  >
    <Button
      title="Cancel"
      styleType={ButtonStyleTypes.ActiveB}
      onClick={onCancel}
    />
    <Button
      title="Save"
      styleType={ButtonStyleTypes.ActiveA}
      onClick={onConfirm}
    />
  </div>
);

export default MapControlConfirm;
